import App from './App';
import { I18nextProvider } from "react-i18next"
import i18next from 'i18next';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store';
import { ChakraProvider} from "@chakra-ui/react";
import theme from "./chakra-theme"; 

import "./translations/translator"
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <ChakraProvider theme={theme}>
    <I18nextProvider i18n={ i18next }>
        <Provider store={ store } >
            <App />
        </Provider>
    </I18nextProvider>
  </ChakraProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
